import { matchPath } from 'react-router';
import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { getContactMembersLoading, isEditModalOpen } from 'modules/contactMembers/selectors';
import { getCurrentLocation } from 'selectors/router';

import { getContactListById, getRoot, getUIState } from '.';
import { ADD_MODE, MAX_CONTACTS } from '../constants';

const getDetailsState = createSelector(getUIState, state => state.details);

export const getSelectedContactListId = createSelector(getCurrentLocation, location => {
  const match = matchPath(PATH.CONTACT_LISTS_DETAILS.path, location);
  return match?.params?.contactListId;
});

export const getSelectedContactList = createSelector(getRoot, getSelectedContactListId, getContactListById);

export const initialized = createSelector(getDetailsState, state => state.initialized);

export const saving = createSelector(getDetailsState, state => state.loading.save);

export const deleting = createSelector(getDetailsState, state => state.loading.delete);

export const exporting = createSelector(getDetailsState, state => state.loading.export);

export const adding = createSelector(getDetailsState, state => state.loading.adding);

const importing = createSelector(getDetailsState, state => state.loading.importing);

const getEditId = createSelector(getDetailsState, state => state.editing.contactListId);

export const isExportModalOpen = createSelector(getEditId, contactListId => Boolean(contactListId));

const getAddId = createSelector(getDetailsState, state => state.adding.contactListId);

export const isAddModalOpen = createSelector(getAddId, contactListId => Boolean(contactListId));

export const getAddMode = createSelector(getDetailsState, state => state.adding.mode);

export const isUploadModalOpen = createSelector(
  isAddModalOpen,
  getAddMode,
  (isOpen, mode) => isOpen && mode === ADD_MODE.UPLOAD
);

export const isContactModalOpen = createSelector(
  isAddModalOpen,
  getAddMode,
  isEditModalOpen,
  (isAddOpen, mode, isEditing) => isEditing || (isAddOpen && mode === ADD_MODE.MANUALLY)
);

const isImporting = createSelector(getSelectedContactListId, importing, (contactListId, importingState) => importingState[contactListId]);

export const getSocketSubscription = createSelector(getSelectedContactListId, contactListId => ({
  entityType: ENTITY_TYPE.CONTACT_LIST,
  entityId: contactListId,
}));

export const getContactListCountMemberCount = createSelector(
  getSelectedContactList,
  /** @param {import("../types").DetailedContactList} contactList */
  contactList => contactList.membersCount
);

export const hasReachedMaxContacts = createSelector(
  getSelectedContactList,
  contactList => contactList.membersCount >= MAX_CONTACTS
);

export const isContactCreationDisabled = createSelector(
  getContactMembersLoading,
  hasReachedMaxContacts,
  isImporting,
  (loading, hasReachedMax, isAdding) => isAdding || (!loading && hasReachedMax)
);
